<template>
  <div class="page"></div>
</template>

<script>


export default {
  beforeMount() {
    window.location = 'https://www.mikmak.tv/home'
  }
}
</script>



// WEBPACK FOOTER //
// RedirectView.vue?60258bf8